import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import {
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';

import './central.scss';
import Crosssection from './Crosssection';
import CentralToolbar from './CentralToolbar';

const useStyles = makeStyles(() => ({
  root: {}
}));

export default function Central(props) {
  const { source, ...rest } = props;

  const classes = useStyles();

  const centralData = source;
  if (centralData.crosssections === undefined) {
    centralData.crosssections = [];
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root)}
    >
      <CardHeader
        title={centralData.project.name}
        subheader={centralData.name}
      />
      <CardContent>

        <CentralToolbar source={source} />

        <div className="plan">

          <div className="FromArea">
            <div className="innerArea">
              <ArrowForwardIcon className="icon" />
              <div className="label">{centralData.from}</div>
              <ArrowForwardIcon className="icon" />
            </div>
          </div>

          {centralData.crosssections.map((crosssection) => {
            return (
              <Crosssection key={crosssection.name} crosssection={crosssection} />
            )
          })}

          <div className="ToArea">
            <div className="innerArea">
              <ArrowForwardIcon className="icon" />
              <div className="label">{centralData.to}</div>
              <ArrowForwardIcon className="icon" />
            </div>
          </div>

        </div>
      </CardContent>
    </Card>
  );
};

Central.propTypes = {
  source: PropTypes.object.isRequired
};
